import { forwardRef } from 'react';

interface ElipsisTextProps {
    text: string;
    length: number;
    flowing?: boolean;
    hoverable?: boolean;
}

export const EllipsisText = forwardRef<HTMLSpanElement, ElipsisTextProps>(
    (props: ElipsisTextProps, ref) => {
        const ellipsis = '...';
        const { text, length, ...other } = props;
        const notNullText = text || '';

        if (notNullText.length <= length || length < 0) {
            return <span {...other}>{notNullText}</span>;
        } else {
            const displayText = notNullText.slice(0, length);
            return (
                <span ref={ref} {...other}>
                    {displayText}
                    {ellipsis}
                </span>
            );
        }
    },
);
EllipsisText.displayName = 'EllipsisText';
